const swiper_custom = new Swiper('.article__swiper_custom', {
  loop: false,
  slidesPerView: "auto",
  navigation: { 
    nextEl: '.swiper-button-next-blog-posts',
    prevEl: '.swiper-button-prev-blog-posts',
  },

  // And if we need scrollbar  
  breakpoints: {
          320: {
            slidesPerView: "auto",
            spaceBetween: 16,
          },
          767: {
            slidesPerView: "auto",
            spaceBetween: 16,
          },
          1025: {
            // slidesPerView: 3,
            spaceBetween: 25,
          },
  },
});
